// Packages
import { useContext, useState, useEffect } from "react";

// Context
import { Language } from "../../Language/Language";

// Elements
import {
  ModalContainer,
  Cross,
  TsAndCsBanner,
  CloseBanner,
  CloseButton,
  TsAndCsWrapper,
  TabButtons,
  TabButton,
  CardImage,
  TsAndCsContent,
} from "./Modal.elements";

import {
  Dropdown,
  DropdownItem,
} from "../Common/Dropdown.elements";

// Icons
import {
  IconDownChevron
} from "./TsAndCsModal.icons"

export default function TsAndCsModal({ isOpen, onClose }) {
  const { tsAndCs: copy } = useContext(Language);
  const [activeTab, setActiveTab] = useState(
    copy.gold ? "gold" : copy.platinum ? "platinum" : "centurion"
  );
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768); // Adjust breakpoint as needed
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isOpen) return null;

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setDropdownOpen(false); // Close dropdown when an item is selected
  };

  const hasMoreThanOneHtml = () => {
    const htmlValues = Object.values(copy)
      .filter((value) => value && typeof value === "object" && "html" in value)
      .map((value) => value.html);

    const nonEmptyHtmlCount = htmlValues.filter(
      (html) => html.trim() !== ""
    ).length;

    return nonEmptyHtmlCount > 1;
  };

  const renderTabButtons = () => (
    <TabButtons className="tab-buttons">
      {copy.gold?.html && (
        <TabButton
          className={activeTab === "gold" ? "active" : ""}
          style={{
            backgroundColor: activeTab === "gold" ? "#ECEDEE" : "",
            color: activeTab === "gold" ? "#333" : "#007bff",
          }}
          onClick={() => handleTabClick("gold")}
        >
          <CardImage cardType={"gold"} />
          Gold Card
        </TabButton>
      )}
      {copy.platinum?.html && (
        <TabButton
          className={activeTab === "platinum" ? "active" : ""}
          style={{
            backgroundColor: activeTab === "platinum" ? "#ECEDEE" : "",
            color: activeTab === "platinum" ? "#333" : "#007bff",
          }}
          onClick={() => handleTabClick("platinum")}
        >
          <CardImage cardType={"platinum"} />
          Platinum Card
        </TabButton>
      )}
      {copy.centurion?.html && (
        <TabButton
          className={activeTab === "centurion" ? "active" : ""}
          style={{
            backgroundColor: activeTab === "centurion" ? "#ECEDEE" : "",
            color: activeTab === "centurion" ? "#333" : "#007bff",
          }}
          onClick={() => handleTabClick("centurion")}
        >
          <CardImage cardType={"centurion"} />
          Centurion Card
        </TabButton>
      )}
    </TabButtons>
  );

  const renderDropdown = () => (
    <Dropdown className="tab-dropdown">
      <div className="dropdown" onClick={() => setDropdownOpen(!dropdownOpen)}>
        <div className="selected-option">
          <CardImage cardType={activeTab} />
          {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Card
        </div>
        {dropdownOpen && (
          <div className="dropdown-menu">
            {copy.gold?.html && (
              <DropdownItem
                onClick={() => handleTabClick("gold")}
                active={activeTab === "gold"}
              >
                <CardImage cardType="gold" />
                Gold Card
              </DropdownItem>
            )}
            {copy.platinum?.html && (
              <DropdownItem
                onClick={() => handleTabClick("platinum")}
                active={activeTab === "platinum"}
              >
                <CardImage cardType="platinum" />
                Platinum Card
              </DropdownItem>
            )}
            {copy.centurion?.html && (
              <DropdownItem
                onClick={() => handleTabClick("centurion")}
                active={activeTab === "centurion"}
              >
                <CardImage cardType="centurion" />
                Centurion Card
              </DropdownItem>
            )}
          </div>
        )}
        <IconDownChevron active={dropdownOpen}/>
      </div>
    </Dropdown>
  );

  return (
    <ModalContainer
      id="modal"
      tabIndex="0"
      style={{ visibility: isOpen ? "" : "hidden" }}
      type="tsandcs"
    >
      <TsAndCsBanner>
        {copy.title}
        <Cross onClick={onClose}>
          <span className="visuallyHidden">{copy.close}</span>
        </Cross>
      </TsAndCsBanner>
      {hasMoreThanOneHtml() &&
        (isSmallScreen ? renderDropdown() : renderTabButtons())}
      <TsAndCsWrapper>
        {activeTab === "gold" && (
          <TsAndCsContent
            dangerouslySetInnerHTML={{
              __html: copy.gold.html || "",
            }}
          ></TsAndCsContent>
        )}
        {activeTab === "platinum" && (
          <TsAndCsContent
            dangerouslySetInnerHTML={{
              __html: copy.platinum.html || "",
            }}
          ></TsAndCsContent>
        )}
        {activeTab === "centurion" && (
          <TsAndCsContent
            dangerouslySetInnerHTML={{
              __html: copy.centurion.html || "",
            }}
          ></TsAndCsContent>
        )}
      </TsAndCsWrapper>
      <CloseBanner>
        <CloseButton role="button" tabIndex="0" onClick={onClose}>
          {copy.close}
        </CloseButton>
      </CloseBanner>
    </ModalContainer>
  );
}
